export default {
    abs: "абс.",
    activate: "Активувати",
    add_category: "Додати категорію",
    add_kit: "Додати комплект",
    additional_materials: "Додаткові матеріали",
    archive: "Архів",
    are_you_sure_you_want_to_delete_category: "Ви впевнені, що хочете видалити категорію?",
    are_you_sure_you_want_to_delete_service: "Ви впевнені, що хочете видалити послугу?",
    assistant_reward: "Винагорода помічника",
    average_price: "Середня ціна",
    categories: "Категорії",
    category: "Категорія",
    change_category: "Змінити категорію",
    change_pricelist: "Змінити прайс",
    classificator_code: "Код по класифікатору",
    classificator_title: "Назва по класифікатору",
    complex_service: "Комплексна послуга",
    complex_services: "Комплексні послуги",
    curator_reward: "Винагорода куратора",
    current_value: "Поточна вартість",
    deactivate: "Деактивувати",
    decrease_price: "Зменшити ціну",
    discounted_price: "Ціна зі знижкою",
    do_not_accrue_bonus: "Не нараховувати бонус",
    doctor_reward: "Винагорода лікаря",
    fill_from_previous_visits: "Заповнити з попередніх візитів",
    fixed_materials_expense_sum: "Фіксована сума витрат на матеріали",
    import_standard_services: "Імпорт стандартних послуг",
    increase_price: "Збільшити ціну",
    individual_bonus: "Індивідуальний бонус пацієнту (%)",
    make_separate: "Зробити окремим",
    manager: "Адміністратор",
    manager_reward: "Винагорода адміністратора",
    mkb_10_diagnosis: "Діагноз по МКХ 10",
    money_lost_on_discount: "Втрата грошей на знижках",
    move_to_group: "Перемістити до групи",
    ndfl_code: "Код НДФЛ",
    not_selected: "Не вказано",
    packages_cost: "Собівартість комплектів",
    personal_percent_for_assistant: "Персональний відсоток для помічника",
    personal_percent_for_curator: "Персональний відсоток для куратора",
    personal_percent_for_doctor: "Персональний відсоток для лікаря",
    personal_percent_for_manager: "Персональний відсоток для адміністратора",
    personal_percent_for_technic: "Персональний відсоток для техніка",
    price_can_be_changed: "Ціна може змінюватися в картці лікування",
    price_from: "Ціна від",
    pricelist_price: "Ціна по прайсу",
    pricelist_short: "Прайс",
    reset_selection: "Скинути вибірку",
    send_to_archive: "Відправити в архів",
    Service: "Послуга",
    service_category: "Категорія",
    service_code: "Код послуги",
    services_not_selected: "Послуги не вибрані",
    technic: "Технік",
    technic_reward: "Винагорода техніка",
    teeth_not_selected: "Зуби не вибрані",
    use_visit_anamnez: "Використати анамнез візиту",
    visit_status: "Статус відвідування"
}
